import __request__ from "routing/request";
export function helloWorld() {
  return __request__("GET", "/", null, {}, {
    "Accept": ["application/json"]
  });
}
